'use client';

import type { FC } from 'react';
import { QuickEditToolForm } from '../_components/quick-edit/QuickEditToolForm';

const ImageEditForm: FC = () => {
  return <QuickEditToolForm mode="image" />;
};

export default ImageEditForm;
